import React from "react";
import styled from "styled-components";
import { useData } from "./DataContext";
import logoTurismo from "./assets/logoCataTurismo.png";
import DotLoader from "react-spinners/DotLoader";

const Contenedor = styled.div`
  width: 100%;
  margin: 1rem 1.5rem 3.5rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  p {
    margin: 0px;
  }
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    justify-content: center;
  }
`;
const ContenedorTable = styled.div`
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  table {
    margin: auto;
    width: 450px;
    table-layout: fixed;
  }
`;
const LoadingDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 2px;
  align-items: center;
  p {
    font-size: 20px;
  }
`;

function ServiciosReceptivos({ perfil }) {
  /*///////////////dataContext/////////////////////////*/
  const { loading, fechaData, costoUnidadesData, sueldoData } = useData();
  const fechaFactor = fechaData[0]?.fecha;
  const sueldoNeto = sueldoData[0]?.sueldo;
  const {
    costoBusDoble: costoBusDobleData,
    costoBus40: costoBus40Data,
    costoVan19: costoVan19Data,
  } = costoUnidadesData[0] || {};

  /*////////////////////////////////////////*/

  /*factor estacionalidad*/
  let mes;
  if (fechaFactor) {
    let opciones = { month: "long" };
    mes = new Intl.DateTimeFormat("es-ES", opciones).format(
      new Date(fechaFactor)
    );
  }

  const fechaValor =
    mes === "diciembre" ||
    mes === "enero" ||
    mes === "febrero" ||
    mes === "marzo"
      ? 1.6
      : 1.4;
  /*base tarifaria = base tar. media x factor estac. + 35 y 30 %*/
  const tarifaBusDoble = costoBusDobleData * fechaValor * 1.35;
  const tarifaBus40 = costoBus40Data * fechaValor * 1.3;
  const tarifaBaseVan19 = costoVan19Data * 10;
  const tarifaVan19 = costoVan19Data * 1.3;
  /*tarifaEspera: se calcula 44 horas semanales * 4 semanas * 60 min. para sacar el $ x minuto y multiplicarlo por la cantidad de minutos*/
  const tarifaVan19_180 = (sueldoNeto / 10560) * 180;
  const tarifaVan19_360 = (sueldoNeto / 10560) * 360;

  const privado = [
    {
      kms: "60",
      servicio: "Aeropuerto /hotel céntrico",
      Van19: tarifaVan19 * 60 + tarifaBaseVan19,
      Minibus24: ((tarifaVan19 * 60 + tarifaBaseVan19) / 19) * 24,
      Bus40: tarifaBus40 * 60,
      BusDoble: tarifaBusDoble * 60,
    },
    {
      kms: "60",
      servicio: "Terminal /hotel céntrico",
      Van19: tarifaVan19 * 60 + tarifaBaseVan19,
      Minibus24: ((tarifaVan19 * 60 + tarifaBaseVan19) / 19) * 24,
      Bus40: tarifaBus40 * 60,
      BusDoble: tarifaBusDoble * 60,
    },
    {
      kms: "60",
      servicio: "Aeropuerto /hotel Chacras o Luján",
      Van19: tarifaVan19 * 60 + tarifaBaseVan19,
      Minibus24: ((tarifaVan19 * 60 + tarifaBaseVan19) / 19) * 24,
      Bus40: tarifaBus40 * 60,
      BusDoble: tarifaBusDoble * 60,
    },
    {
      kms: "60",
      servicio: "Terminal /hotel Chacras o Luján",
      Van19: tarifaVan19 * 60 + tarifaBaseVan19,
      Minibus24: ((tarifaVan19 * 60 + tarifaBaseVan19) / 19) * 24,
      Bus40: tarifaBus40 * 60,
      BusDoble: tarifaBusDoble * 60,
    },
    {
      kms: "100",
      servicio: "Mendoza /Cacheuta /Mendoza FD (hasta 8hs) 1 destino",
      Van19: tarifaVan19 * 100 + tarifaBaseVan19 + tarifaVan19_360,
      Minibus24:
        ((tarifaVan19 * 100 + tarifaBaseVan19 + tarifaVan19_360) / 19) * 24,
      Bus40: tarifaBus40 * 120,
      BusDoble: tarifaBusDoble * 120,
    },
    {
      kms: "160",
      servicio: "Mendoza /Potrerillos /Mendoza FD (hasta 8 hs) 1 destino",
      Van19: tarifaVan19 * 160 + tarifaBaseVan19 + tarifaVan19_360,
      Minibus24:
        ((tarifaVan19 * 160 + tarifaBaseVan19 + tarifaVan19_360) / 19) * 24,
      Bus40: tarifaBus40 * 180,
      BusDoble: tarifaBusDoble * 180,
    },
    {
      kms: "260",
      servicio: "Mendoza /Uspallata /Mendoza (hasta 8 hs) 1 destino",
      Van19: tarifaVan19 * 260 + tarifaBaseVan19 + tarifaVan19_360,
      Minibus24:
        ((tarifaVan19 * 260 + tarifaBaseVan19 + tarifaVan19_360) / 19) * 24,
      Bus40: tarifaBus40 * 280,
      BusDoble: tarifaBusDoble * 280,
    },
    {
      kms: "380",
      servicio: "Mendoza /Penitentes /Mendoza (FD hasta 8 hs) 1 destino",
      Van19: tarifaVan19 * 380 + tarifaBaseVan19,
      Minibus24: ((tarifaVan19 * 380 + tarifaBaseVan19) / 19) * 24,
      Bus40: tarifaBus40 * 380,
      BusDoble: tarifaBusDoble * 380,
    },
    {
      kms: "180",
      servicio:
        "Mendoza /Tupungato o Tunuyan /Mendoza (FD hasta 8 hs) 1 destino",
      Van19: tarifaVan19 * 180 + tarifaBaseVan19 + tarifaVan19_360,
      Minibus24:
        ((tarifaVan19 * 180 + tarifaBaseVan19 + tarifaVan19_360) / 19) * 24,
      Bus40: tarifaBus40 * 200,
      BusDoble: tarifaBusDoble * 200,
    },
    {
      kms: "180",
      servicio:
        "Mendoza /hotel en Tupungato o Tunuyan o vv (por tramo) 1 destino",
      Van19:
        tarifaVan19 * 90 +
        tarifaBaseVan19 +
        (costoVan19Data - (costoVan19Data * 30) / 100) * 90,
      Minibus24:
        ((tarifaVan19 * 90 +
          tarifaBaseVan19 +
          (costoVan19Data - (costoVan19Data * 30) / 100) * 90) /
          19) *
        24,
      Bus40: tarifaBus40 * 180,
      BusDoble: tarifaBusDoble * 180,
    },
    {
      kms: "480",
      servicio: "Mendoza /San Rafael, cdad. /Mendoza (FD hasta 8hs)",
      Van19: tarifaVan19 * 480 + tarifaBaseVan19,
      Minibus24: ((tarifaVan19 * 480 + tarifaBaseVan19) / 19) * 24,
      Bus40: tarifaBus40 * 480,
      BusDoble: tarifaBusDoble * 480,
    },
    {
      kms: "60",
      servicio: "Traslado hotel /Restaurant centro /hotel con espera * 3hs.",
      Van19: tarifaVan19 * 60 + tarifaBaseVan19 + tarifaVan19_180,
      Minibus24:
        ((tarifaVan19 * 60 + tarifaBaseVan19 + tarifaVan19_180) / 19) * 24,
      Bus40: tarifaBus40 * 70,
      BusDoble: tarifaBusDoble * 70,
    },
    {
      kms: "60",
      servicio: "Traslado hotel /Restaurant Chacras /hotel con espera * 3hs.",
      Van19: tarifaVan19 * 60 + tarifaBaseVan19 + tarifaVan19_180,
      Minibus24:
        ((tarifaVan19 * 60 + tarifaBaseVan19 + tarifaVan19_180) / 19) * 24,
      Bus40: tarifaBus40 * 70,
      BusDoble: tarifaBusDoble * 70,
    },
    {
      kms: "60",
      servicio: "Traslado Mendoza Plaza Shopping o Palmares con espera * 3hs.",
      Van19: tarifaVan19 * 60 + tarifaBaseVan19 + tarifaVan19_180,
      Minibus24:
        ((tarifaVan19 * 60 + tarifaBaseVan19 + tarifaVan19_180) / 19) * 24,
      Bus40: tarifaBus40 * 70,
      BusDoble: tarifaBusDoble * 70,
    },
    {
      kms: "150",
      servicio: "Servicio a disposicion 08 hs a 20 hs (hasta 150 km)",
      Van19: tarifaVan19 * 150 + tarifaBaseVan19 + tarifaVan19_360,
      Minibus24:
        ((tarifaVan19 * 150 + tarifaBaseVan19 + tarifaVan19_360) / 19) * 24,
      Bus40: tarifaBus40 * 170,
      BusDoble: tarifaBusDoble * 170,
    },
  ];
  const bodegas = [
    {
      kms: "240",
      servicio: "HD Traslado bodega Zuccardi c/espera",
      Van19: tarifaVan19 * 240 + tarifaBaseVan19 + tarifaVan19_180,
      Minibus24:
        ((tarifaVan19 * 240 + tarifaBaseVan19 + tarifaVan19_180) / 19) * 24,
      Bus40: tarifaBus40 * 250,
      BusDoble: tarifaBusDoble * 250,
    },
    {
      kms: "80",
      servicio: "HD Traslado bodega Chandon c/espera",
      Van19: tarifaVan19 * 80 + tarifaBaseVan19 + tarifaVan19_180,
      Minibus24:
        ((tarifaVan19 * 80 + tarifaBaseVan19 + tarifaVan19_180) / 19) * 24,
      Bus40: tarifaBus40 * 90,
      BusDoble: tarifaBusDoble * 90,
    },
    {
      kms: "80",
      servicio: "HD Traslado bodega Ruca Malen c/espera",
      Van19: tarifaVan19 * 80 + tarifaBaseVan19 + tarifaVan19_180,
      Minibus24:
        ((tarifaVan19 * 80 + tarifaBaseVan19 + tarifaVan19_180) / 19) * 24,
      Bus40: tarifaBus40 * 90,
      BusDoble: tarifaBusDoble * 90,
    },
    {
      kms: "60",
      servicio: "HD Traslado bodega Lagarde c/espera",
      Van19: tarifaVan19 * 60 + tarifaBaseVan19 + tarifaVan19_180,
      Minibus24:
        ((tarifaVan19 * 60 + tarifaBaseVan19 + tarifaVan19_180) / 19) * 24,
      Bus40: tarifaBus40 * 70,
      BusDoble: tarifaBusDoble * 70,
    },
    {
      kms: "60",
      servicio: "HD Traslado bodega Nieto Senetiner c/espera",
      Van19: tarifaVan19 * 60 + tarifaBaseVan19 + tarifaVan19_180,
      Minibus24:
        ((tarifaVan19 * 60 + tarifaBaseVan19 + tarifaVan19_180) / 19) * 24,
      Bus40: tarifaBus40 * 70,
      BusDoble: tarifaBusDoble * 70,
    },
    {
      kms: "200",
      servicio: "Traslado bodega Salentein o Andeluna c/espera",
      Van19: tarifaVan19 * 200 + tarifaBaseVan19 + tarifaVan19_180,
      Minibus24:
        ((tarifaVan19 * 200 + tarifaBaseVan19 + tarifaVan19_180) / 19) * 24,
      Bus40: tarifaBus40 * 210,
      BusDoble: tarifaBusDoble * 210,
    },
  ];
  const convencionales = [
    {
      kms: "80",
      servicio: "Ciudad y alrededores – HD",
      Van19: tarifaVan19 * 80 + tarifaBaseVan19 + tarifaVan19_180,
      Minibus24:
        ((tarifaVan19 * 80 + tarifaBaseVan19 + tarifaVan19_180) / 19) * 24,
      Bus40: tarifaBus40 * 90,
      BusDoble: tarifaBusDoble * 90,
    },
    {
      kms: "120",
      servicio: "Bodegas + aceitera Maipu – HD",
      Van19: tarifaVan19 * 120 + tarifaBaseVan19 + tarifaVan19_180,
      Minibus24:
        ((tarifaVan19 * 120 + tarifaBaseVan19 + tarifaVan19_180) / 19) * 24,
      Bus40: tarifaBus40 * 130,
      BusDoble: tarifaBusDoble * 130,
    },
    {
      kms: "120",
      servicio: "Villavicencio – HD",
      Van19: tarifaVan19 * 120 + tarifaBaseVan19 + tarifaVan19_180,
      Minibus24:
        ((tarifaVan19 * 120 + tarifaBaseVan19 + tarifaVan19_180) / 19) * 24,
      Bus40: tarifaBus40 * 130,
      BusDoble: tarifaBusDoble * 130,
    },
    {
      kms: "460",
      servicio: "Alta montaña sin cristo – FD",
      Van19: tarifaVan19 * 460 + tarifaBaseVan19,
      Minibus24: ((tarifaVan19 * 460 + tarifaBaseVan19) / 19) * 24,
      Bus40: tarifaBus40 * 460,
      BusDoble: tarifaBusDoble * 460,
    },
    {
      kms: "600",
      servicio: "Cañon del Atuel – FD",
      Van19: tarifaVan19 * 600 + tarifaBaseVan19,
      Minibus24: ((tarifaVan19 * 600 + tarifaBaseVan19) / 19) * 24,
      Bus40: tarifaBus40 * 600,
      BusDoble: tarifaBusDoble * 600,
    },
  ];
  const especiales = [
    {
      kms: "120",
      servicio: "HD Ciudad, alrededores + 1 bodega (Maipu)",
      Van19: tarifaVan19 * 120 + tarifaBaseVan19 + tarifaVan19_180,
      Minibus24:
        ((tarifaVan19 * 120 + tarifaBaseVan19 + tarifaVan19_180) / 19) * 24,
      Bus40: tarifaBus40 * 130,
      BusDoble: tarifaBusDoble * 130,
    },
    {
      kms: "150",
      servicio:
        "FD Bodegas (hasta 3) – Maipu o Lujan, con espera para almuerzo",
      Van19: tarifaVan19 * 150 + tarifaBaseVan19 + tarifaVan19_360,
      Minibus24:
        ((tarifaVan19 * 150 + tarifaBaseVan19 + tarifaVan19_360) / 19) * 24,
      Bus40: tarifaBus40 * 170,
      BusDoble: tarifaBusDoble * 170,
    },
    {
      kms: "200",
      servicio: "FD Bodegas (hasta 3) – Valle de Uco corto",
      Van19: tarifaVan19 * 200 + tarifaBaseVan19 + tarifaVan19_360,
      Minibus24:
        ((tarifaVan19 * 200 + tarifaBaseVan19 + tarifaVan19_360) / 19) * 24,
      Bus40: tarifaBus40 * 220,
      BusDoble: tarifaBusDoble * 220,
    },
    {
      kms: "250",
      servicio:
        "FD Bodegas (hasta 3) – Valle de Uco largo (Alfa Crux o Piedra Infinita)",
      Van19: tarifaVan19 * 250 + tarifaBaseVan19 + tarifaVan19_360,
      Minibus24:
        ((tarifaVan19 * 250 + tarifaBaseVan19 + tarifaVan19_360) / 19) * 24,
      Bus40: tarifaBus40 * 270,
      BusDoble: tarifaBusDoble * 270,
    },
  ];

  return (
    <>
      <div style={{ textAlign: "center", width: "100%" }}>
        <img src={logoTurismo} width="150" alt="Logo de Cata Turismo" />
      </div>
      <Contenedor>
        {loading && (
          <LoadingDiv>
            <p>Cargando tarifas...</p>
            <DotLoader color="#c20000" size={40} />
          </LoadingDiv>
        )}
        {!loading && (
          <ContenedorTable>
            <table>
              <thead>
                <tr>
                  {perfil ? (
                    <>
                      <th style={{ padding: "0 15px", width: "50px" }}>kms</th>
                    </>
                  ) : null}

                  <th style={{ padding: "0 15px", width: "530px" }}>
                    TRASLADOS PRIVADOS
                  </th>
                  <th style={{ padding: "0 15px", width: "110px" }}>Van19</th>
                  <th style={{ padding: "0 15px", width: "110px" }}>
                    Minibus24
                  </th>
                  <th style={{ padding: "0 15px", width: "110px" }}>Bus40</th>
                  <th style={{ padding: "0 15px", width: "110px" }}>
                    BusDoble
                  </th>
                </tr>
              </thead>
              <tbody>
                {privado.map((tarifa, index) => (
                  <tr key={index}>
                    {perfil ? (
                      <>
                        <td style={{ padding: "0 15px" }}>{tarifa.kms}</td>
                      </>
                    ) : null}
                    <td style={{ padding: "0 15px" }}>{tarifa.servicio}</td>
                    <td style={{ padding: "0 15px" }}>
                      ${Math.round(tarifa.Van19).toLocaleString("es-AR")}
                    </td>
                    <td style={{ padding: "0 15px" }}>
                      ${Math.round(tarifa.Minibus24).toLocaleString("es-AR")}
                    </td>
                    <td style={{ padding: "0 15px" }}>
                      ${Math.round(tarifa.Bus40).toLocaleString("es-AR")}
                    </td>
                    <td style={{ padding: "0 15px" }}>
                      ${Math.round(tarifa.BusDoble).toLocaleString("es-AR")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <table>
              <thead>
                <tr>
                  {perfil ? (
                    <>
                      <th style={{ padding: "0 15px", width: "50px" }}>kms</th>
                    </>
                  ) : null}
                  <th style={{ padding: "0 15px", width: "530px" }}>
                    TRASLADOS A BODEGAS
                  </th>
                  <th style={{ padding: "0 15px", width: "110px" }}>Van19</th>
                  <th style={{ padding: "0 15px", width: "110px" }}>
                    Minibus24
                  </th>
                  <th style={{ padding: "0 15px", width: "110px" }}>Bus40</th>
                  <th style={{ padding: "0 15px", width: "110px" }}>
                    BusDoble
                  </th>
                </tr>
              </thead>
              <tbody>
                {bodegas.map((tarifa, index) => (
                  <tr key={index}>
                    {perfil ? (
                      <>
                        <td style={{ padding: "0 15px" }}>{tarifa.kms}</td>
                      </>
                    ) : null}
                    <td style={{ padding: "0 15px" }}>{tarifa.servicio}</td>
                    <td style={{ padding: "0 15px" }}>
                      ${Math.round(tarifa.Van19).toLocaleString("es-AR")}
                    </td>
                    <td style={{ padding: "0 15px" }}>
                      ${Math.round(tarifa.Minibus24).toLocaleString("es-AR")}
                    </td>
                    <td style={{ padding: "0 15px" }}>
                      ${Math.round(tarifa.Bus40).toLocaleString("es-AR")}
                    </td>
                    <td style={{ padding: "0 15px" }}>
                      ${Math.round(tarifa.BusDoble).toLocaleString("es-AR")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <table>
              <thead>
                <tr>
                  {perfil ? (
                    <>
                      <th style={{ padding: "0 15px", width: "50px" }}>kms</th>
                    </>
                  ) : null}
                  <th style={{ padding: "0 15px", width: "530px" }}>
                    EXCURSIONES CONVENCIONALES
                  </th>
                  <th style={{ padding: "0 15px", width: "110px" }}>Van19</th>
                  <th style={{ padding: "0 15px", width: "110px" }}>
                    Minibus24
                  </th>
                  <th style={{ padding: "0 15px", width: "110px" }}>Bus40</th>
                  <th style={{ padding: "0 15px", width: "110px" }}>
                    BusDoble
                  </th>
                </tr>
              </thead>
              <tbody>
                {convencionales.map((tarifa, index) => (
                  <tr key={index}>
                    {perfil ? (
                      <>
                        <td style={{ padding: "0 15px" }}>{tarifa.kms}</td>
                      </>
                    ) : null}
                    <td style={{ padding: "0 15px" }}>{tarifa.servicio}</td>
                    <td style={{ padding: "0 15px" }}>
                      ${Math.round(tarifa.Van19).toLocaleString("es-AR")}
                    </td>
                    <td style={{ padding: "0 15px" }}>
                      ${Math.round(tarifa.Minibus24).toLocaleString("es-AR")}
                    </td>
                    <td style={{ padding: "0 15px" }}>
                      ${Math.round(tarifa.Bus40).toLocaleString("es-AR")}
                    </td>
                    <td style={{ padding: "0 15px" }}>
                      ${Math.round(tarifa.BusDoble).toLocaleString("es-AR")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <table>
              <thead>
                <tr>
                  {perfil ? (
                    <>
                      <th style={{ padding: "0 15px", width: "50px" }}>kms</th>
                    </>
                  ) : null}
                  <th style={{ padding: "0 15px", width: "530px" }}>
                    EXCURSIONES ESPECIALES EN PRIVADO
                  </th>
                  <th style={{ padding: "0 15px", width: "110px" }}>Van19</th>
                  <th style={{ padding: "0 15px", width: "110px" }}>
                    Minibus24
                  </th>
                  <th style={{ padding: "0 15px", width: "110px" }}>Bus40</th>
                  <th style={{ padding: "0 15px", width: "110px" }}>
                    BusDoble
                  </th>
                </tr>
              </thead>
              <tbody>
                {especiales.map((tarifa, index) => (
                  <tr key={index}>
                    {perfil ? (
                      <>
                        <td style={{ padding: "0 15px" }}>{tarifa.kms}</td>
                      </>
                    ) : null}
                    <td style={{ padding: "0 15px" }}>{tarifa.servicio}</td>
                    <td style={{ padding: "0 15px" }}>
                      ${Math.round(tarifa.Van19).toLocaleString("es-AR")}
                    </td>
                    <td style={{ padding: "0 15px" }}>
                      ${Math.round(tarifa.Minibus24).toLocaleString("es-AR")}
                    </td>
                    <td style={{ padding: "0 15px" }}>
                      ${Math.round(tarifa.Bus40).toLocaleString("es-AR")}
                    </td>
                    <td style={{ padding: "0 15px" }}>
                      ${Math.round(tarifa.BusDoble).toLocaleString("es-AR")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </ContenedorTable>
        )}
      </Contenedor>
    </>
  );
}

export default ServiciosReceptivos;
